(function () {
angular.module("gulp-client", [])
.constant("DefaultLocalization", "fr");
})();
